export default __webpack_public_path__ + "static/media/h-1.f920e405.jpg";